import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  commodities: [],
  commodityWiseDetails: [],
};

const commodityDetailedPage = createSlice({
  name: "commodityDetailedPage",
  initialState,
  reducers: {
    fetchCommodities(state) {},
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {},

    getCommodityWiseDetailedOrders(state) {},
    getCommodityWiseDetailedOrdersSuccess(state, action) {
      state.commodityWiseDetails = action.payload.data;
    },
    getCommodityWiseDetailedOrdersFailure(state, action) {},

   
  },
});

export const { actions, reducer, name: sliceKey } = commodityDetailedPage;
